import { map, pipe, toArray } from "@fxts/core"

import { CustomerModel, CustomerStaffModel } from "@/features/customers"
import { formatBusinessRegistrationNumber, formatPhoneNumber } from "@/utils/formats"

import { FetchCustomerApi } from "./apis"

export const toSelectCustomerModel = <T extends FetchCustomerApi["Response"]>(
  data: T,
): CustomerModel => {
  return {
    ...data,
    staffs: toSelectCustomerStaffModel(data.staffs),
    businessRegistrationNumber: formatBusinessRegistrationNumber(
      data.businessRegistrationNumber,
    ),
  }
}

export const toSelectCustomerStaffModel = <T extends CustomerStaffModel>(
  staffs: T[],
): CustomerStaffModel[] => {
  const staffModels = pipe(
    staffs,
    map(staff => {
      return {
        ...staff,
        email: staff.email,
        displayName: staff.displayName || "",
        telephone: formatPhoneNumber(staff.telephone || ""),
      } satisfies CustomerStaffModel
    }),
    toArray,
  )
  return staffModels
}
